import React from 'react';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { ShowDialogParams } from '@/store/dialog/types';
import { getEditorTemplateObjectStore, IncrementAutosaveCounter, SetBodyPart } from '@/store/templateEditor/actions';
import { EditMimeModalBody } from '../components/EditMimeModalBody';

interface GetEditBodyPartModalParamsProps {
    contentType: string;
    title: string;
    alert: string | JSX.Element;
    label: string;
}

export const useEditBodyPartModalParams = (): {
    getEditBodyPartModalParams: (props: GetEditBodyPartModalParamsProps) => ShowDialogParams;
} => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const templateObject = useSelector(getEditorTemplateObjectStore);

    const getEditBodyPartModalParams = ({
        title,
        alert,
        contentType,
        label,
    }: GetEditBodyPartModalParamsProps): ShowDialogParams => {
        let newValue;

        const updateValue = (text: string): void => {
            newValue = text;
        };

        const saveValue = (): void => {
            if (isNil(newValue)) {
                return;
            }
            dispatch(SetBodyPart(contentType, newValue));
            dispatch(IncrementAutosaveCounter());
        };

        const body = (
            <EditMimeModalBody
                templateObject={templateObject}
                contentType={contentType}
                alert={alert}
                label={label}
                onChange={updateValue}
            />
        );
        return {
            title,
            confirmLabel: t('save'),
            cancelLabel: t('cancel'),
            onClickConfirm: saveValue,
            body,
            id: 'editmimetext',
        };
    };
    return { getEditBodyPartModalParams };
};
